var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008AFB;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill-12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "YoutubeCover-Copy-2",
    transform: "translate(-1112.000000, -174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1112.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drift_logo_white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue-Inverted_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Branding"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue-Inverted",
    transform: "translate(0.079843, 0.121653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M199.8,0C89.4,0,0,89.5,0,199.8c0,110.4,89.4,199.8,199.8,199.8 c110.3,0,199.8-89.5,199.8-199.8C399.5,89.5,310.1,0,199.8,0L199.8,0L199.8,0z M193.5,250c0,3-1.6,5.9-4.2,7.4 c-2.6,1.5-5.8,1.5-8.4,0c0,0,0,0-0.1,0l-35.5-20.7v76.8c0,3-1.6,5.9-4.2,7.4c-1.3,0.8-2.8,1.1-4.2,1.1s-2.9-0.4-4.2-1.1 l-21.2-12.4c-2.6-1.5-4.2-4.3-4.2-7.4v-86.7l-34.3-20c-2.6-1.5-4.2-4.3-4.2-7.4V154c0-3,1.6-5.9,4.2-7.4 c2.6-1.5,5.8-1.5,8.4,0l107.8,62.8c2.6,1.5,4.2,4.3,4.2,7.4V250L193.5,250L193.5,250z M195.3,117.2c0,4.2-2.2,8.1-5.9,10.2 l-31,18.1c-1,0.6-1.6,1.7-1.6,2.8v23.1c0,2.5-2.7,4.2-4.9,2.9c-13.1-7.6-48.9-28.5-62-36c-2.2-1.3-2.1-4.4,0-5.7l92.7-54 c2.6-1.5,5.8-1.5,8.4,0c2.6,1.5,4.2,4.3,4.2,7.4V117.2L195.3,117.2L195.3,117.2z M206,86c0-3,1.6-5.8,4.2-7.4 c2.6-1.5,5.8-1.5,8.4,0l92.6,54c2.2,1.3,2.3,4.5,0,5.8c-13.1,7.6-48.6,28.3-61.8,35.9c-2.2,1.3-5-0.3-5-2.9v-23 c0-1.2-0.6-2.3-1.7-2.9l-32.6-19c-2.6-1.5-4.2-4.3-4.2-7.4V86L206,86L206,86z M330.7,187.1c0,3-1.6,5.9-4.2,7.4l-34.3,20 v86.7c0,3-1.6,5.8-4.2,7.4l-21.2,12.4c-1.3,0.8-2.8,1.1-4.2,1.1c-1.5,0-2.9-0.4-4.2-1.1c-2.6-1.5-4.2-4.3-4.2-7.4v-76.8 l-35.5,20.7c0,0-0.1,0-0.1,0c-2.6,1.5-5.8,1.5-8.4,0c-2.6-1.5-4.2-4.3-4.2-7.4v-33.1c0-3,1.6-5.9,4.2-7.4l107.8-62.8 c2.6-1.5,5.8-1.5,8.4,0c2.6,1.5,4.2,4.3,4.2,7.4V187.1L330.7,187.1L330.7,187.1z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrift);
export default __webpack_public_path__ + "static/media/drift.cdfffa8056ee787a89e15baa1d96ca34.svg";
export { ForwardRef as ReactComponent };